import { Button } from "@/shared/components/ui/button";
import { FilePlusCorner } from "lucide-react";

export default function NoSpecifications({
  onCreateSpecificationWithAi,
  onImportSpecification,
}: {
  onCreateSpecificationWithAi: () => void;
  onImportSpecification: () => void;
}) {
  return (
    <>
      <div className="w-[36px] h-[36px] rounded-[8px] mb-[15px] bg-white border border-border flex items-center justify-center">
        <FilePlusCorner height={20} width={20} color="#09090B" />
      </div>
      <h3 className="text-base font-semibold mb-[4px]">Şartname yok</h3>
      <p className="text-[14px] font-600 text-muted-foreground">
        Şartname oluşturun veya yükleyin; ardından tedarikçilerden yanıt
        toplayın.
      </p>

      <div className="mt-[15px] flex gap-2  justify-center">
        <Button
          size="sm"
          variant="outline"
          onClick={onCreateSpecificationWithAi}
        >
          AI ile şartnameni oluştur
        </Button>
        <Button size="sm" onClick={onImportSpecification}>
          Şartnemeni birleştir veya yükle
        </Button>
      </div>
    </>
  );
}
